import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  routeURL: string;
  constructor(
    private router: Router
  ) {
    this.routeURL = this.router.url;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    return new Promise((resolve, reject) => {

      if (!sessionStorage.getItem('token') ) {
        this.routeURL = '/login';
        this.router.navigate(['/login'], {
          queryParams: {
            return: 'login'
          }
        });
        return resolve(false)
      } else {
        this.routeURL = this.router.url;
        return resolve(true)
      }
    });
  }
}
